<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>Buyer Info.
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <div class="articleEn">
      <div class="contentBox">
        <!-- left -->
        <div class="proLeft NoShowInMobile align_c">
          <img src="@/assets/images/iconApp.svg" width="100%" />
        </div>
        <!-- left end -->
        <div class="proRight">
          <div class="MbDevice">
            <!-- <h1><img src="@/assets/images/iconApp.svg" width="35px" class="mb-1" /> Buyer Info.</h1> -->

            <div class="d-flex align-items-center">
              <div>
                <img src="@/assets/images/iconApp.svg" width="35px" class="mt-1 mr-1" />
              </div>
              <div>
                <h1>Buyer Info.</h1>
              </div>
            </div>
          </div>
          <div class="PcDevice">
            <h1>Buyer Info.</h1>
          </div>
          <p class="my-3">&nbsp;</p>
          <p>
            Exhibitors can also use【Chan Chao Lead Retrieval App】 to scan and easily get hold of the buyers
            information. Scanning the Chan Chao member card to get the visitor's basic and personal information, such as
            his/her name, company name, department name, job title, phone number, email and nationality.
          </p>
          <p class="my-3">&nbsp;</p>
          <div class="hide">
            <p>Available：<span class="red" name="OpenDay"></span> ( Day before exhibition )</p>
            <p>Scanned Time：<span class="red" name="date"></span> ( During the exhibition )</p>
            <p>Closed：<span class="red" name="CloseDay"></span> ( 30 days after the exhibition )</p>
            <p class="my-3">&nbsp;</p>

            <div class="d-flex">
              <div id="btnColor">
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeGetCard?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  class="iframeFull btnStyle AddRegLink"
                  >Data</a
                >
              </div>

              <!-- <div id="btnColor" class="ml-4">
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeGetCardInfo?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  class="iframeFull btnStyle linkstyle"
                  >帳號管理</a
                >
              </div> -->
            </div>
          </div>
          <p class="lightLine">&nbsp;</p>
          <h1>Chan Chao Scanner APP</h1>
          <p class="my-3">&nbsp;</p>
          <h4>Three steps to get【Chan Chao Lead Retrieval App】</h4>
          <p class="my-3">&nbsp;</p>
          <ol class="number">
            <li>At the Apple Store or Google Play Store app and search【Chan Chao Scanner APP】and install.</li>
            <li>Open the APP and sign in with your username and password.</li>
            <li>Click [Scanned Profile]-selcet [Exhibitions List] then select your exhibition.</li>
          </ol>
          <p class="my-3">&nbsp;</p>
          <img src="@/assets/images/appDownload.jpg" class="picForMobile" />
          <p class="my-3">&nbsp;</p>
          Sub-account management, labels, data export…and more functions.
          <a target="_blank" class="linkstyle" href="https://www.chanchao.com.tw/qa/getBuyer/app/en/"
            >Learn more about Chan Chao Lead Retrieval App</a
          >
          <p class="lightLine">&nbsp;</p>
          <h1>Contact</h1>
          <p class="my-3">&nbsp;</p>
          <div name="ExpoContact"></div>
        </div>
        <p class="clear"></p>
        <p class="my-3">&nbsp;</p>
        <div class="alert">
          <p class="bold">Terms of use</p>
          <p class="divider">&nbsp;</p>
          <ol class="number">
            <li>Available：<span name="date"></span></li>
            <li>
              Price: The discounted price for each App account is NT$5,250 excluding tax (Original price NT$6,300
              excluding tax).
            </li>
            <li>
              After the account is created, please download 【Chan Chao Scanner APP】. All functions will be available
              after the application is completed on <span name="OpenDay"></span>. Each main account can add three
              sub-accounts.
            </li>
            <li>
              The scanned data during the exhibition can be checked and downloaded in the exhibitor management system.
              The App function and the information page of the exhibitor management system will be closed on
              <span name="CloseDay"></span>. Please pay attention to the time.
            </li>
            <li>
              Visitors retain the right to decide whether or not to have their barcodes scanned. If any visitor declines
              the scan, exhibitors are prohibited from forcibly scanning the barcode of the visitor. In case any dispute
              emerges, please go to the information counter to seek settlement advices from the staff of the show
              organizers.
            </li>
            <li>
              The personal data of buyers is collected by the organizer in compliance with the "Personal Data Protection
              Act" of the Republic of China and stored in the cloud database linked to the QR Code of each buyer.
            </li>
            <li>
              Exhibitors can scan and easily get hold of the buyers information. Scanning the Chan Chao member card to
              get the visitor's basic and personal information, such as his/her name, company name, department name, job
              title, phone number, email and nationality. The above information is filled in by the buyer during
              registration, and the organizer does not guarantee the completeness and correctness of the information.
            </li>
            <li>
              Buyers have the right to decide whether to allow exhibitors to scan their QR Code (just as buyers can
              decide whether to provide their personal business cards). This service does not mean that exhibitors have
              the right to own all the buyer's information. Exhibitors can only get the buyer's personal information
              from scanning their QR Code.
            </li>
            <li>
              The buyer's information obtained by exhibitors is only for your company's use. Please ensure that it is
              properly maintained in accordance with the " Personal Data Protection Act" of the Republic of China, and
              must not be sold or provided to others illegally.
            </li>
            <li>
              Please do not use this system in an illegal manner. If any improper use is found, the organizer reserves
              the right to terminate this service.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    components: {},

    metaInfo() {
      return {
        title: 'Buyer Info. - ExhibitorServiceTW',
      }
    },

    data() {
      return {
        Exhdate: '',
        ExhVenue: '',
        ExhibitionName: '',
        UserId: '',
        RegNo: '',

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {},

    created() {
      const vm = this

      let lang = 'en'

      //url取出展碼
      let nowPage = location.href
      vm.RegNo = nowPage.split('no=')[1]

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      $(function () {
        let lang = 'en'
        $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
          //exh detail
          $('[name="date"]').text(data.Data.ExhBegin + ' - ' + data.Data.ExhEnd)

          //OpenDay
          var OpenDay = new Date(data.Data.ExhBegin)

          OpenDay.setDate(OpenDay.getDate() - 1)
          $('[name="OpenDay"]').text(formatDate(OpenDay))

          function formatDate(date) {
            var d = new Date(date),
              month = '' + (d.getMonth() + 1),
              day = '' + d.getDate(),
              year = d.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('/')
          }

          //close day
          var CloseDay = new Date(data.Data.ExhEnd)
          CloseDay.setDate(CloseDay.getDate() + 30)
          $('[name="CloseDay"]').text(formatDate(CloseDay))
        })

        //contact info
        $.getJSON('/apiExhibitors/AdvContact/' + vm.RegNo, { lang: lang }, function (data) {
          $('[name="ExpoContact"]').html(data.Data.AdvContact)
        })
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })
    },
  }
</script>

<style lang="scss">
  #btnColor a:hover {
    color: #ffffff;
  }
</style>
